import { Injectable } from "@angular/core";
import {
  CanLoad,
  Route,
  UrlSegment,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  UrlTree,
  Router
} from "@angular/router";

import { Observable } from "rxjs";
import { map } from "rxjs/operators";

import { AuthenticationService } from "../fire-auth/authentication.service";

@Injectable({
  providedIn: "root"
})
export class AuthenticationGuard {
  constructor(
    private authenticationService: AuthenticationService,
    private router: Router
  ) {}
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    return this.authenticationService.getStatus().pipe(
      map(status => {
        if (status) return true;
        else {
          this.router.navigate(["not-authorized"]);
          return false;
        }
      })
    );
  }
}
